import { render } from "./RequestLicenseModal.vue?vue&type=template&id=3927d0ac&scoped=true"
import script from "./RequestLicenseModal.vue?vue&type=script&lang=js"
export * from "./RequestLicenseModal.vue?vue&type=script&lang=js"

import "./RequestLicenseModal.vue?vue&type=style&index=0&id=3927d0ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3927d0ac"]])

export default __exports__